(()=>{
  const dealerPopupSelectors = {
    dealerElement : '.hc-dealer-info',
    dealerButton: '.hc-dealer-icon',
    closeElement :'.hc-dealer-close',
    productForm: '#add-to-cart-form',
    tabsWrapper:'.hc-tabs-wrapper',
  };
  function toggleDealerPopup(){  
      const $dealerElement = document.querySelector(dealerPopupSelectors.dealerElement);
      const $productForm = document.querySelector(dealerPopupSelectors.productForm);
      const $tabsWrapper = document.querySelector(dealerPopupSelectors.tabsWrapper);
      $productForm.classList.toggle('hc-hidden');
      $dealerElement.classList.toggle('hc-hidden');
      $tabsWrapper.classList.toggle('hc-hidden');
  }
  const $dealerButton = document.querySelector(dealerPopupSelectors.dealerButton) || null;
  if($dealerButton){
   const $closeElement = document.querySelector(dealerPopupSelectors.closeElement)
    $dealerButton.addEventListener('click', toggleDealerPopup)
    $closeElement.addEventListener('click', toggleDealerPopup)
  }
  const tabsContentSelectors = {
    tabsHeading: '.hc-tablinks',
    tabsContents: '.hc-tabcontent'
  };
  const $tabsTitles = [...document.querySelectorAll(tabsContentSelectors.tabsHeading)] || null;
  if($tabsTitles){
      const $tabsContent = [...document.querySelectorAll(tabsContentSelectors.tabsContents)];
      $tabsTitles.forEach($tab => {
          $tab.addEventListener('click', function(){
            const { element } = this.dataset;
            $tabsTitles.filter($button => $button !== $tab).map($button => $button.classList.remove('active'));
            this.classList.add('active');
            $tabsContent.find( $content => $content.dataset.element === element).classList.remove('hc-hidden');
            $tabsContent.filter( $content => $content.dataset.element !== element).map($content => $content.classList.add('hc-hidden'));
          })
      })
  }
  const modalsSelectors = {
    buttonModals:'.hc-icon-content',
    show:'hc-show',
    modal:'modal'
  }
  const $buttonsModals = [...document.querySelectorAll(modalsSelectors.buttonModals)] || null;
    $buttonsModals.forEach($button =>{
      $button.addEventListener('click', function(){
        const { id } = this.dataset;
        document.querySelector(`#${id}`).classList.add(modalsSelectors.show);
      })
    })
    window.addEventListener('click', function(event){
      
      if(event.target.classList.contains(modalsSelectors.modal)){
        event.target.classList.remove(modalsSelectors.show)
      }
      if(event.target.classList.contains('close')){
       const { popup } = event.target.dataset;
       document.querySelector(`#${popup}`).classList.remove(modalsSelectors.show);
      }
    })
  
})();